export default __webpack_public_path__ + "static/media/special-gift.b18fc701.png";